module.exports = __webpack_public_path__ + "static/apple_store_badge-9beaa0db7ef2975ab326f0a2639bd0e1.svg";